import React from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import { ConfirmProps, IExportedConfirm } from './index.d';

const container = document.getElementById('prompt');

const Confirm = (props: ConfirmProps) => {
  const { title, text, onConfirm, onCancel, confirmBtnText,cancelBtnText, holdbackdrop = false } = props;
  const confirm = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }
    ReactDOM.unmountComponentAtNode(container as HTMLElement);
  };

  const cancel = () => {
    onCancel && onCancel();
    ReactDOM.unmountComponentAtNode(container as HTMLElement);
  };

  const clickBackground = (event: React.MouseEvent): void => {
    if ((event.target as HTMLElement).id === 'bgAlert' && !holdbackdrop) {
      cancel();
    }
  };

  return (
    <div id="bgAlert" className="flex bg-modal" onClick={clickBackground}>
      <div className="move-in-up" styleName="modal-content">
        <div styleName="title">{title || ''}</div>
        {text ? <div styleName="text">{text}</div> : null}
        <div className="flex" styleName="btns-bottom">
          <div className="flex flex-center" styleName="button-cancel" onClick={cancel}>
            {cancelBtnText || '取 消'}
          </div>
          <div className="flex flex-center" styleName="button-confirm" onClick={confirm}>
            {confirmBtnText || '确 定'}
          </div>
        </div>
      </div>
    </div>
  );
};

const ExportedConfirm: IExportedConfirm = {
  show(options) {
    /* eslint-disable no-param-reassign */
    if (typeof options === 'string') {
      options = {
        title: options,
      };
    }
    /* eslint-enable no-param-reassign */
    ReactDOM.render(<Confirm {...options} />, container);
  },
};

export default ExportedConfirm;
